import(/* webpackMode: "eager" */ "/app/apps/website/src/app/(rootLayout)/conseils-inspirations/[slug]/_components/markdown-styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollBar"] */ "/app/apps/website/src/app/(rootLayout)/conseils-inspirations/[slug]/_components/scroll-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/app/apps/website/src/app/(rootLayout)/conseils-inspirations/[slug]/_components/share-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
